module.exports = __webpack_public_path__ + "img/成果展示 国企单位.fdb6daa5.png";